import { render, staticRenderFns } from "./FixedAssetEdited.vue?vue&type=template&id=4cca6040"
import script from "./FixedAssetEdited.vue?vue&type=script&lang=js"
export * from "./FixedAssetEdited.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports